<div class="notch"></div>
<header class="page-header" role="banner">
  <!-- we need this logo when user switches to nav-function-top {{version}} -->
  <ng-container *defineVariable="mobileService.mobileState$ | async as mobileState">
    @if (!isLogin || isDeeplink) {
      <smart-logo [isDeeplink]="isDeeplink"></smart-logo>
    }
    @if (!mobileState.mobile || isDeeplink) {
      <shop-name [isDeeplink]="isDeeplink"></shop-name>
    }
  </ng-container>
  <!-- DOC: mobile button appears during mobile width -->
  @if (!isLogin && !isDeeplink) {
    <div class="hidden-lg-up">
      <a
        href="#"
        (click)="openMobileNav($event)"
        class="header-btn btn press-scale-down"
        data-action="toggle"
        data-class="mobile-nav-on"
        >
        <em class="fas fa-bars"></em>
      </a>
    </div>
  }
  @if (!isLogin && !isDeeplink) {
    <search class="search"></search>
  }
  @if (!isLogin && !isDeeplink) {
    <div class="ms-auto d-flex">
      @if (view === View.CLIENT) {
        <!-- app user menu -->
        <workflow-task-counter></workflow-task-counter>
        <span class="me-2">
          <basket-header></basket-header>
        </span>
      }
      <smart-dropdown-user></smart-dropdown-user>
    </div>
  }
</header>
